import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

@Component({
	selector: "ui-double-button",
	templateUrl: "./button.component.html",
	styleUrls: ["./button.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class DoubleButtonComponent {
	@Output() action = new EventEmitter<void>();
	@Output() actionRight = new EventEmitter<void>();
	@Input() disabled: boolean;
	@Input() icon: string;
	@Input() loading: boolean;
	@Input() type?: "primary" | "secondary" | "danger" = "secondary";
	@Input() help?: string;

	@HostBinding("attr.tabIndex") tabIndex = -1;

	clickLeft() {
		this.action.emit();
	}

	clickRight() {
		if (this.actionRight.observed) {
			this.actionRight.emit();
		} else {
			this.action.emit();
		}
	}

	get iconClass() {
		if (this.loading) {
			return "fa fa-spin fa-refresh";
		}

		return this.icon;
	}
}
